// src/client/components/NavBar.tsx
// Floating translucent bottom nav. 4 tabs: Home, Loans, Repay, Profile.
// Active route gets the solid accent fill and the label slides in.
import { NavLink } from 'react-router-dom';
import { Home, Wallet, Send, User } from 'lucide-react';
import { ROUTES } from '@/constants/routes';
import styles from './NavBar.module.css';

const ITEMS = [
  { to: ROUTES.home,      label: 'Home',    Icon: Home },
  { to: ROUTES.loansList, label: 'Loans',   Icon: Wallet },
  { to: ROUTES.repay,     label: 'Repay',   Icon: Send },
  { to: ROUTES.profile,   label: 'Profile', Icon: User },
] as const;

export default function NavBar() {
  return (
    <nav className={styles.nav} aria-label="Primary">
      <ul className={styles.list}>
        {ITEMS.map(({ to, label, Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              className={({ isActive }) =>
                [styles.item, isActive && styles.active].filter(Boolean).join(' ')
              }
              end
            >
              <Icon size={18} aria-hidden strokeWidth={1.8} />
              {/* Label is RIGHT of icon — slides in when active */}
              <span className={styles.label}>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
